const clients = [];
const currentClient = {}
const totalClients = 0
const pendenciesClients = 0
const averagePaymentTime = 0

export default {
  clients,
  currentClient,
  totalClients,
  pendenciesClients,
  averagePaymentTime,
};
